import { API } from 'aws-amplify';
import { getConfig } from '../config/graphql';

export const NETWORK_RESTRICTION_ERROR_TYPE = 'WAFForbiddenException';

const ERROR_TYPE_HEADER = 'x-amzn-errortype';

export type GraphqlAccess = 'restricted' | 'allowed';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const readHeader = (headers: Record<string, unknown>, name: string): string | undefined => {
  const key = Object.keys(headers).find((k) => k.toLowerCase() === name);
  const value = key === undefined ? undefined : headers[key];
  return typeof value === 'string' ? value : undefined;
};

// Amplify 5 rejects with { data, errors: [GraphQLError(originalError = axios error)] }.
export function isNetworkRestrictionError(error: unknown): boolean {
  if (!isRecord(error) || !Array.isArray(error.errors)) return false;
  const first: unknown = error.errors[0];
  if (!isRecord(first) || !isRecord(first.originalError)) return false;
  const { response } = first.originalError;
  if (!isRecord(response) || response.status !== 403 || !isRecord(response.headers)) return false;
  const errorType = readHeader(response.headers, ERROR_TYPE_HEADER);
  if (errorType === undefined) return false;
  return errorType.split(':')[0].trim().toLowerCase() === NETWORK_RESTRICTION_ERROR_TYPE.toLowerCase();
}

// Calls API.graphql directly: graphqlService.js re-wraps errors as text and loses status and headers.
export async function checkGraphqlAccess(): Promise<GraphqlAccess> {
  try {
    await API.graphql({ query: getConfig, authToken: 'auth' });
    return 'allowed';
  } catch (error) {
    return isNetworkRestrictionError(error) ? 'restricted' : 'allowed';
  }
}
